/**
 * Maximum length for thread names generated from message text.
 */
export const MAX_THREAD_NAME_LENGTH = 50;

/**
 * Regex pattern for detecting "Untitled Thread" names.
 * Matches "Untitled Thread" or "Untitled Thread N" where N is a number.
 */
export const UNTITLED_THREAD_NAME_REGEX = /^Untitled Thread( [0-9]+)?$/;

/**
 * Creates a thread name from message text by truncating to MAX_THREAD_NAME_LENGTH
 * and appending "..." if truncated.
 */
export function threadNameFromMessageText(text: string): string {
    return text.length > MAX_THREAD_NAME_LENGTH ? text.substring(0, MAX_THREAD_NAME_LENGTH).trim() + "..." : text;
}

/**
 * Checks if a thread name matches the "Untitled Thread" pattern.
 */
export function isUntitledThreadName(name: string | undefined): boolean {
    return !!name && UNTITLED_THREAD_NAME_REGEX.test(name);
}
